module.exports = __webpack_public_path__ + "fonts/fa-solid-900.5dc01cfc.woff2";